var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconSingleNeutralActionsAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17.25a6 6 0 1 0 12 0 6 6 0 1 0-12 0Zm6-3v6m-3-3h6m-19.5 0a6.753 6.753 0 0 1 9.4-6.208M3.375 4.875a4.125 4.125 0 1 0 8.25 0 4.125 4.125 0 1 0-8.25 0Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconSingleNeutralActionsAdd);
export default __webpack_public_path__ + "static/media/streamline-icon-single-neutral-actions-add.0c63a9b7.svg";
export { ForwardRef as ReactComponent };